import { cloneDeep } from "lodash";

import { upsertOption } from "~/utilities/reducer";
import { isBrowser } from "~/utilities/helpers";

export const headerInitialState = {
    mobileMenuIsOpen: false,
    mobileSubNavIsOpen: "",
    openTopSubnav: null,
    openMainSubnav: "",
    searchIsOpen: false,
    exitBodyScrollLock: false,
    openLangSubNav: false,
    openCountrySubNav: false,
};

export const headerReducer = (state, action) => {
    let updatedState = cloneDeep(state);

    const { type, id, hasSubitems } = action;
    const {
        searchIsOpen,
        mobileMenuIsOpen,
        openTopSubnav,
        openMainSubnav,
        openLangSubNav,
    } = updatedState;

    switch (type) {
        case "HANDLE_MOUSE_ENTER":
            updatedState = upsertOption(updatedState, {
                openMainSubnav:
                    !searchIsOpen && !mobileMenuIsOpen && hasSubitems ? id : "",
            });
            break;
        case "HANDLE_MOUSE_ENTER_TOP":
            updatedState = upsertOption(updatedState, {
                openTopSubnav: !searchIsOpen && hasSubitems ? id : null,
            });
            break;
        case "HANDLE_MOUSE_LEAVE":
            updatedState = upsertOption(updatedState, {
                openTopSubnav: hasSubitems ? null : openTopSubnav,
                openMainSubnav: hasSubitems ? "" : openMainSubnav,
            });
            break;
        case "HANDLE_MOUSE_ENTER_LANG":
            updatedState = upsertOption(updatedState, {
                openLangSubNav: !searchIsOpen && hasSubitems ? id : null,
            });
            break;
        case "HANDLE_MOUSE_LEAVE_LANG":
            updatedState = upsertOption(updatedState, {
                openLangSubNav: hasSubitems ? null : openLangSubNav,
                openMainSubnav: hasSubitems ? "" : openMainSubnav,
            });
            break;
        // copy handle_mouse actions to country selector
        case "HANDLE_MOUSE_ENTER_COUNTRY":
            updatedState = upsertOption(updatedState, {
                openCountrySubNav: !searchIsOpen && hasSubitems ? id : null,
            });
            break;
        case "HANDLE_MOUSE_LEAVE_COUNTRY":
            updatedState = upsertOption(updatedState, {
                openCountrySubNav: hasSubitems ? null : openLangSubNav,
                openMainSubnav: hasSubitems ? "" : openMainSubnav,
            });
            break;
        case "HANDLE_MOBILE_MENU_TOGGLE":
            updatedState = upsertOption(updatedState, {
                mobileMenuIsOpen: true,
                searchIsOpen: false,
            });
            break;
        case "HANDLE_MOBILE_NAVIGATION_CLOSE":
            updatedState = upsertOption(updatedState, {
                mobileMenuIsOpen: false,
                mobileSubNavIsOpen: "",
            });
            break;
        case "CLOSE_MOBILE_MENU":
            updatedState = upsertOption(updatedState, {
                mobileSubNavIsOpen: "",
                mobileMenuIsOpen: false,
                exitBodyScrollLock: true,
            });
            break;
        case "HANDLE_MOBILE_SUB_NAV":
            updatedState = upsertOption(updatedState, {
                mobileSubNavIsOpen:
                    mobileMenuIsOpen && hasSubitems ? action.id : "",
            });
            break;
        case "HANDLE_MOBILE_SUB_NAV_CLOSE":
            updatedState = upsertOption(updatedState, {
                mobileSubNavIsOpen: "",
            });
            break;
        case "HANDLE_SEARCH_TOGGLE":
            updatedState = upsertOption(updatedState, {
                searchIsOpen: searchIsOpen ? false : true,
                openMainSubnav:
                    !searchIsOpen && !mobileMenuIsOpen && hasSubitems ? id : "",
                mobileMenuIsOpen: false,
            });
            break;
        case "HANDLE_SEARCH_CLOSE":
            updatedState = upsertOption(updatedState, {
                searchIsOpen: false,
                openMainSubnav: hasSubitems ? "" : openMainSubnav,
            });
            break;
        case "HANDLE_CLOSE_ALL":
            updatedState = upsertOption(updatedState, {
                mobileMenuIsOpen: false,
                mobileSubNavIsOpen: "",
                searchIsOpen: false,
                openMainSubnav: hasSubitems ? "" : openMainSubnav,
                openTopSubnav: hasSubitems ? null : openTopSubnav,
                exitBodyScrollLock: true,
            });
            break;
        default:
            if (isBrowser) {
                console.log(`Unkown Header Action ${type}`);
            }
            break;
    }

    return updatedState;
};
